export default __webpack_public_path__ + "static/media/nepal.92a656e5.png";